module.exports = __webpack_public_path__ + "img/pattern3.494cb5b.svg";